








import Vue from 'vue';
import VueMarkdown from 'vue-markdown';

export default Vue.extend({
    name: 'Code',
    components: {
        VueMarkdown,
    },
    computed: {
        code() {
            return this.$route.params.code;
        },
    },
});
